import { memo } from "react";
import { FormattedMessage } from "react-intl";

import { Badge } from "common/core/badge";

const SeenBefore = memo(
  ({ seenBefore, withBadge = true }: { seenBefore?: boolean; withBadge?: boolean }) => {
    if (seenBefore === undefined) {
      return <>--</>;
    }

    const content = seenBefore ? (
      <FormattedMessage id="a9fae101-dcaf-489c-a608-4efa9d20f27f" defaultMessage="Yes" />
    ) : (
      <FormattedMessage id="df8ff51e-6791-4a3c-82d0-61a20f93d781" defaultMessage="No" />
    );

    return withBadge ? <Badge kind={seenBefore ? "success" : "warning"}>{content}</Badge> : content;
  },
);

export default SeenBefore;
